import { UserAccountActiveStatus, userAccountActiveStatus } from "modules/common";
import React, { useContext } from "react";
import { Filter, ToggleSwitch } from "..";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Props {
    onChange: (status: UserAccountActiveStatus) => void;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClear: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
    isActive: boolean;
    showDropdown: boolean;
    value: UserAccountActiveStatus[];
}

export const StatusFilter: React.FC<Props> = ({
    onChange,
    onClick,
    onClear,
    isActive,
    showDropdown,
    value,
}) => {
    const { lowVision } = useContext(AccessibilityContext);
    return (
        <Filter
            isActive={isActive}
            showDropdown={showDropdown}
            onClick={onClick}
            onClear={onClear}
            text="STATUS"
        >
            <div>
                <ToggleSwitch
                    value={userAccountActiveStatus.Active.value.toString()}
                    checked={value.includes(userAccountActiveStatus.Active.value)}
                    onChange={() => onChange(userAccountActiveStatus.Active.value)}
                    htmlFor={userAccountActiveStatus.Active.label}
                    text={
                        <div className={lowVision ? "low-vision-white-text" : "filter__item__text"}>
                            {userAccountActiveStatus.Active.label.toLocaleUpperCase()}
                        </div>
                    }
                />
            </div>
            <div>
                <ToggleSwitch
                    value={userAccountActiveStatus.Inactive.value.toString()}
                    checked={value.includes(userAccountActiveStatus.Inactive.value)}
                    onChange={() => onChange(userAccountActiveStatus.Inactive.value)}
                    htmlFor={userAccountActiveStatus.Inactive.label}
                    text={
                        <div className={lowVision ? "low-vision-white-text" : "filter__item__text"}>
                            {userAccountActiveStatus.Inactive.label.toLocaleUpperCase()}
                        </div>
                    }
                />
            </div>
        </Filter>
    );
};
